import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import * as MuiIcons from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface MuiIconPickerProps {
  icons: typeof MuiIcons;
  onSelect: (iconName: string) => void;
}

export const MuiIconPicker: React.FC<MuiIconPickerProps> = ({
  icons,
  onSelect,
}) => {
  const { t } = useTranslation();
  // Extract all valid icon names.
  // We filter out non-components and variations to keep the list manageable.
  const iconNames = Object.keys(icons).filter(
    (name) =>
      /^[A-Z]/.test(name) &&
      !name.endsWith('Outlined') &&
      !name.endsWith('Rounded') &&
      !name.endsWith('TwoTone') &&
      !name.endsWith('Sharp')
  );

  return (
    <Autocomplete
      options={iconNames}
      onChange={(_, newValue) => onSelect(newValue || '')}
      renderOption={(props, option) => {
        const Icon = icons[option as keyof typeof MuiIcons];
        return (
          <li {...props} key={option}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              {Icon && <Icon fontSize="small" />}
              {option}
            </Box>
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={t('poiForm.searchIcons')} size="small" />
      )}
    />
  );
};
